var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":true}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}),_c('div',{staticClass:"text-center mt-3"},[_vm._v("Application is being updated, please try again later...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }